export const esri = {
  map: {
    basemap: 'dark-gray'
  }
};
